import { Link } from "react-router-dom";
import { ArrowRight, Clock, Users, Compass } from "lucide-react";
import { Reveal } from "@/components/Primitives";
import { InnerHero, CTABand } from "@/components/Sections";
import { IMG, DESTINATIONS } from "@/data/site";

export default function Destinations() {
  return (
    <>
      <InnerHero
        overline="Destinations Across India"
        title="Where to wander, slowly"
        subtitle="From Kerala's backwaters to Karnataka's coffee hills and Goa's quiet coves — thirteen destinations, each with its own rhythm."
        image={IMG.tea1}
      />
      <section className="bg-ivory py-20 md:py-28" data-testid="destinations-grid">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {DESTINATIONS.map((d, i) => (
              <Reveal key={d.name} delay={(i % 3) * 0.07}>
                <div className="group h-full rounded-2xl border border-sand bg-coconut overflow-hidden" data-testid={`destination-card-${i}`}>
                  <div className="relative h-60 overflow-hidden">
                    <img src={d.img} alt={d.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy/70 to-transparent" />
                    <h3 className="absolute bottom-4 left-5 font-serif text-3xl text-ivory">{d.name}</h3>
                  </div>
                  <div className="p-6 space-y-3">
                    <Row icon={Compass} label="Best for" value={d.bestFor} />
                    <Row icon={Users} label="Ideal traveller" value={d.traveller} />
                    <Row icon={Clock} label="Suggested duration" value={d.duration} />
                    <div className="pt-2">
                      <span className="rounded-full border border-gold text-gold text-[0.62rem] tracking-widest uppercase px-3 py-1">{d.type}</span>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTABand
        overline="Plan a route"
        title="Combine destinations into one seamless journey"
        primary={{ label: "Request a Route", to: "/contact" }}
        secondary={{ label: "Sample Itineraries", to: "/itineraries" }}
      />
    </>
  );
}

const Row = ({ icon: Icon, label, value }) => (
  <div className="flex items-start gap-3">
    <Icon size={16} className="text-teal mt-0.5 shrink-0" />
    <p className="text-sm text-navy/70"><span className="text-navy/45">{label}: </span>{value}</p>
  </div>
);
